import { tenantConfig } from "@tenant-config";

export const buildTimeFlags = tenantConfig.features;
